// extracted by mini-css-extract-plugin
export default {"adBox":"AdBox_adBox__bQUY5","hidden":"AdBox_hidden__zrOgO"};